import { Box, Typography, Grid } from '@mui/material'
import { DEAL_STATUS } from '@constants/data'
import USDC_ICON from '@images/ico_usdc.png'
import './StakeItem.scss'

const StakeItem = (props) => {
  const {
    position,
    amount,
    status,
    bonus,
    bonusHide,
    hide,
    isOwn
  } = props;

  return (
    <Grid
      container
      className={`staked-item ${status === 5 ? 'bg-gray' : isOwn ? DEAL_STATUS[status].toLowerCase().replace(/ /g, '-') : "bg-gray"}`}
    >
      <Grid
        item
        xs={4}
        sx={{ display: "flex", justifyContent: "flex-start" }}
      >
        <Box
          className="text-center"
        >
          <Typography
            className="font-24 font-bold"
          >
            {position}
          </Typography>
          {!hide && (
            <Typography
              className="font-sm font-bold"
            >
              MY POSITION
            </Typography>
          )}
        </Box>
      </Grid>
      <Grid
        item
        xs={4}
        sx={{ display: "flex", justifyContent: "flex-end" }}
      >
        {!bonusHide && (
          <Box className="text-center">
            <Typography
              className="font-sm font-bold"
            >
              {bonus} %
            </Typography>
            <Typography
              className="font-sm font-bold uppercase"
            >
              Presail Bonus
            </Typography>
          </Box>
        )}
      </Grid>
      <Grid
        item
        xs={4}
        sx={{ display: "flex", justifyContent: "flex-end" }}
      >
        <Box
          sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
        >
          <Box
            className="text-center"
            sx={{ mr: 1 }}
          >
            <Typography
              className="font-24 font-bold"
            >
              ${amount}
            </Typography>
            {!hide && (
              <Typography
                className="font-sm font-bold"
              >
                MY STAKE
              </Typography>
            )}
          </Box>
          <Box className="coin-icon">
            <img
              src={USDC_ICON}
              alt="USDC Icon"
            />
          </Box>
        </Box>
      </Grid>
    </Grid >
  )
}

export default StakeItem